// Import Vue
import Vue from 'vue'

// Import F7 Bundle
import Framework7 from 'framework7/dist/framework7.esm.bundle.js'

// Import F7-Vue Plugin Bundle (with all F7 components registered)
import Framework7Vue from 'framework7-vue/dist/framework7-vue.esm.bundle.js'

// Import F7 iOS Theme Styles
import 'framework7/dist/css/framework7.min.css'
import 'framework7/dist/css/framework7.ios.min.css'
/* OR for Material Theme:
import Framework7Theme from 'framework7/dist/css/framework7.material.min.css'
import Framework7ThemeColors from 'framework7/dist/css/framework7.material.colors.min.css'
*/

// Import App Custom Styles
import AppStyles from './css/app.css'

// Import Routes
//import Routes from './routes.js'

// Import App Component
import App from './app'
// Init F7 Vue Plugin
Vue.use(Framework7Vue, Framework7)

var VueFire = require('vuefire')

// explicit installation required in module environments
Vue.use(VueFire)

// Init App
new Vue({
  el: '#app',
  template: '<app/>',
  // Init Framework7 by passing parameters here
  framework7: {
    root: '#app',
    theme: 'ios',
    touch: {
      disableContextMenu: false,
      tapHold: true
    },
    statusbar: {
      iosOverlaysWebview: true,
    },
    clicks: {
      externalLinks: '.external, a[target="_blank"]'
    }
    
    /* Uncomment to enable Material theme: */
    // material: true,
    /*routes: Routes,*/
  },
  // Register App Component
  components: {
    app: App
  }
});



// WEBPACK FOOTER //
// ./src/main.js